<script>
	import HelpText from './helptext.html'
	export let config = {};

	export function switchHelp() {
		config.showhelp = config.showhelp.length > 0 ? "" : "hide";
	}
</script>

<style>
	.hide {
		display: none;
	}
</style>

<div class="{config.showhelp}">
	<span on:click="{switchHelp}" class="frame clickable">skrýt nápovědu</span>
	<HelpText/>

	<div>
		<h3>Nastavení</h3>
		<label>
			<input type=checkbox bind:checked={config.showScore}>ukazovat skore
		</label>
	</div>
</div>
